import { useEffect, useRef } from "react";

export const LIVE_STATUS_POLL_MS = 30_000;

/**
 * Chama `callback` a cada `intervalMs` enquanto a aba está visível, e uma vez ao voltar para a aba.
 * Não sobrepõe execuções: se a anterior ainda não terminou, o tick é ignorado.
 */
export function useVisiblePolling(callback: () => Promise<void> | void, intervalMs: number, enabled = true) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled) return;
    let running = false;
    const tick = async () => {
      if (running || document.visibilityState !== "visible") return;
      running = true;
      try {
        await callbackRef.current();
      } catch {
        // best-effort: a próxima rodada tenta de novo
      } finally {
        running = false;
      }
    };
    const id = window.setInterval(() => void tick(), intervalMs);
    document.addEventListener("visibilitychange", tick);
    return () => {
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", tick);
    };
  }, [intervalMs, enabled]);
}
